import React, { useCallback } from "react";

export type LoaderProps = {
	skeleton: any;
	component: any;
	mode?: "rerender";
};

const useLoader = (loading?: boolean) => {
	const Loader: React.FC<LoaderProps> = useCallback(
		({ skeleton, component /*, mode = "rerender" */ }) => {
			const result = (loading ? skeleton : component) ?? null;
			return result;
		},
		[loading],
	);

	return Loader;
};

export default useLoader;
